<div class="container-fluid plan-detail-container plan-details-{{gridContext.viewMode?.toLowerCase()}}"  *ngIf="!_isNestedRoute">
  <div class="row" class="d-none">
    <div class="col">
      Start date:<span class="text-success">{{'01/02/2015' | date:'full'}}</span> -
      End date:<span class="text-success">{{'01/02/2015' | date:'full'}}</span>
    </div>
  </div>
  <div class="row breadcrumb-row">
    <div class="col">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a routerLink="/plans">
            {{"plan.page.title" | translate}}
          </a>
          <esp-icon class="breadcrumb-separator" name="chevron-right"></esp-icon>
        </li>
      </ol>
    </div>
  </div>
  <div class="row mb-2 page-title-container">
    <div class="col page-header plan-detail">
      <wfm-page-title title="{{planName}}"></wfm-page-title>
    </div>
    <div class="col text-right">
      <button id="mu-dist" [ngClass]="{'disabled': _isMUDirty || isManualEditing}" class="btn btn-secondary btn-lg " (click)="navigateToDistribution()" [disabled]="UnappliedChanges || isManualEditing" title="{{'plan.detail.mu.dist.btn'|translate}}">{{"plan.detail.mu.dist.btn"|translate}}</button>
      <div class="d-inline-block" ngbDropdown #myDrop="ngbDropdown">
          <div ngbDropdown class="d-inline-block">
              <button class="btn btn-secondary"  [ngClass]="{'disabled': _isLoading || isManualEditing}" [disabled]="_isLoading || isGridInvalid || isManualEditing" id="dropdownSettings" ngbDropdownToggle title="{{'plan.options'|translate}}" tooltipPosition="left">
                <esp-icon class="toolbar-icon" name="more-actions" [size]="20"></esp-icon>
              </button>

              <div ngbDropdownMenu aria-labelledby="dropdownSettings">
                <button *ngIf="tenantService.isCXOne===false" ngbDropdownItem class="dropdown-item" (click)="showConvertToActiveDialog()" [disabled]="!_userHasModify || UnappliedChanges" id="btn-convert">
                  <esp-icon class="menu-icon" name="check-circle"></esp-icon>
                   {{"plan.convert.active"|translate}}
                </button>

                <div class="dropdown-divider"></div>

                <button ngbDropdownItem class="dropdown-item" [disabled]="isDisableExportAsCsv()" (click)="onBtnExport()" id="btn-export" title='{{"plan.exportcsv"|translate}}'>
                  <esp-icon class="menu-icon" name="file-text"></esp-icon> {{"plan.exportcsv"|translate}}
                </button>

                <button ngbDropdownItem class="dropdown-item" [disabled]="isDisableExportEveryCt()" (click)="onBtnExportEveryCt()" id="btn-exporteveryct">
                  <esp-icon class="menu-icon" name="download"></esp-icon> {{"plan.exporteveryctcsv"|translate}}
                </button>

                <ng-container *ngIf="_planSyncFeature">
                  <div class="dropdown-divider"></div>

                  <button ngbDropdownItem class="dropdown-item" [disabled]="isDisableExportExcel()" (click)="onBtnExportExcel()" id="btn-export-excel" title='{{"plan.exportexcel"|translate}}'>
                    <esp-icon class="menu-icon" name="file-spreadsheet"></esp-icon> {{"plan.exportexcel"|translate}}
                  </button>

                  <button ngbDropdownItem class="dropdown-item" [disabled]="isDisableImportExcel()" (click)="onBtnImportExcel()" id="btn-import-excel" title='{{"plan.importexcel"|translate}}'>
                    <esp-icon class="menu-icon" name="file-up"></esp-icon> {{"plan.importexcel"|translate}}
                  </button>
                </ng-container>

                <div class="dropdown-divider"></div>

                <button ngbDropdownItem class="dropdown-item" [disabled]="UnappliedChanges" (click)="navigateToPlanCtSettings()" id="btn-plan-ct-settings" title='{{"plan.ct.settings.page.title"|translate}}'>
                  <esp-icon class="menu-icon" name="user-cog"></esp-icon> {{"plan.ct.settings.page.title"|translate}}
                </button>
                <button ngbDropdownItem class="dropdown-item"
                        [disabled]="UnappliedChanges"
                        (click)="showPlanSettingsDialog()" id="btn-settings3">
                  <esp-icon class="menu-icon" name="settings"></esp-icon> {{getPlanSettingsText()}}
                </button>

                <button *ngIf="_newHireSettingsFeature" ngbDropdownItem [disabled]="UnappliedChanges" class="dropdown-item" (click)="navigateToNewHireSettings()" id="btn-nhtp-settings">
                  <esp-icon class="menu-icon" name="headphones"></esp-icon> {{"new.hire.page.title" | translate}}
                </button>
                <ng-container *ngIf="_externalForecastFeature">
                  <div class="dropdown-divider"></div>
                  <button [disabled]="UnappliedChanges" class="dropdown-item" (click)="navigateToExternalForecast()" id="btn-plan-external-forecast" title='{{"external.forecast.menu" | translate}}'>
                    <i class="icon icon-Icons_svg_import-forecast-data"></i> {{"external.forecast.menu" | translate}}
                  </button>
                </ng-container>

              </div>
          </div>
      </div>

      <button *ngIf="_userHasModify" id="save-as-btn" [ngClass]="{'disabled':UnappliedChanges || isManualEditing}" class="btn btn-secondary btn-lg  no-right-margin" [disabled]="UnappliedChanges || isGridInvalid || isManualEditing" (click)="showSaveAsDlg()" title='{{"plan.save.as.btn"|translate}}'>{{"plan.save.as.btn"|translate}}</button>
      <button *ngIf="_userHasModify" id="save-btn" [ngClass]="{'disabled': _dataIsSaved || UnappliedChanges || isManualEditing}" class="btn btn-primary btn-lg no-right-margin" [disabled]=" _dataIsSaved || UnappliedChanges || isGridInvalid || isManualEditing" (click)="saveButtonClicked()" title='{{"plan.save"|translate}}'>{{"plan.save"|translate}}</button>


      <breeze-button class="d-none" buttonText="Close" id="btn-cancel-plan" [isPrimary]="true" btnSizeClass="btn-lg no-right-margin">
      </breeze-button>

    </div>
  </div>
  <div class="row toolbar-container text-left no-gutters">
    <div class="toolbar-items-left ctmu-container">
      <div class="btn-group">
        <button id="ct-btn" class="btn btn-secondary btn-rect btn-small float-right" title="{{'plan.details.ct.view.label' | translate}}"
          [ngClass]="{'active':isMUView==false}" (click)="setEntityView('CT')"
          [disabled]="_isLoading || isGridInvalid || disableEntityViewToggle">
          <esp-icon name="user-cog" [size]="20"></esp-icon>
        </button>
        <button id="mu-btn" class="btn btn-secondary btn-rect btn-small float-right" title="{{'plan.details.mu.view.label' | translate}}"
          [ngClass]="{'active':isCTView==false}" (click)="setEntityView('MU')"
          [disabled]="_isLoading || isGridInvalid || disableEntityViewToggle">
            <esp-icon name="building-2" [size]="20"></esp-icon>
        </button>
      </div>
      <!--<span *ngIf="selectedContactType" class="toolbar-label">{{"muct.dropdown.label"|translate}}</span>-->
<!--      <wfm-select *ngIf="selectedContactType" #muctSelector
                  class="contactTypeDropDown toolbar-select"
                  selectName="contactType"
                  selectId="contactType"
                  [items]="contactTypeList"
                  [disabled]="_isLoading || isGridInvalid"
                  (wfmSelectEvent)="updateContactType($event)"
                  [selectedItem]="selectedContactType">
      </wfm-select>-->
      <p-multiselect placeholder=" " #ctSelector
                     *ngIf="isCTView"
                     [ariaLabel]="'plan.details.cts.all' | translate"
                     (click)="onMultiselectContainerClick($event, ctSelector)"
                     class="filterable ct-selector contactTypeDropDown toolbar-select no-x-scroll"
                     [(ngModel)]="selectedCTs"
                     ngDefaultControl
                     [options]="contactTypeList"
                     [showToggleAll]="false"
                     [virtualScroll]="true"
                     scrollHeight="200px"
                     appendTo="body"
                     panelStyleClass="esp-multiselect-fixed-height ct-single-select-overlay"
                     optionLabel="value.label"
                     optionValue="value"
                     [virtualScrollItemSize]="40"
                     (onChange)="updateSelectedCTs($event)"
                     (onPanelShow)="onCtPanelShow()"
                     (onPanelHide)="onCtPanelHide()"
                     [showHeader]="true"
                     [filter]="false"
                     [disabled]="_isLoading || isGridInvalid"
                     emptyFilterMessage="{{'plan.details.dropdown.contact.types.empty' | translate}}"
                     styleClass="fullrow">
        <ng-template let-value pTemplate="selectedItems">
          <!--<ng-container
            *ngTemplateOutlet="multiSelectSelectedItems;
            context: { value: value, emptyMessage: 'historical-data.ct.empty.selection' }">
          </ng-container>-->
          <esp-multi-select-content [items]="value" emptyMessage="plan.details.dropdown.contact.types.empty.selection"> </esp-multi-select-content>
        </ng-template>
        <ng-template pTemplate="header">
          <esp-multi-select-filter [multiSelect]="ctSelector" [displaySelectOptions]=false
            [searchAriaLabel]="'multi.select.filter.search.contact.types' | translate">

          </esp-multi-select-filter>
        </ng-template>
        <ng-template pTemplate="footer">
          <esp-multi-select-footer [multiSelect]="ctSelector">

          </esp-multi-select-footer>
        </ng-template>
        <ng-template let-item pTemplate="item">
          <!--<ng-container *ngTemplateOutlet="multiSelectItem; context:  { $implicit: item }"></ng-container>-->
          <esp-single-select-item [item]="item"></esp-single-select-item>
        </ng-template>
      </p-multiselect>
      <p-multiselect placeholder=" " #muSelector
                     *ngIf="isMUView"
                     [ariaLabel]="'plan.details.dropdown.management.units' | translate"
                     (click)="onMultiselectContainerClick($event, muSelector)"
                     class="filterable mu-selector contactTypeDropDown toolbar-select no-x-scroll"
                     [(ngModel)]="selectedMUs"
                     ngDefaultControl
                     [options]="managementUnitsList"
                     [showToggleAll]="false"
                     [virtualScroll]="true"
                     scrollHeight="200px"
                     appendTo="body"
                     panelStyleClass="esp-multiselect-fixed-height"
                     optionLabel="value.label"
                     optionValue="value"
                     [virtualScrollItemSize]="40"
                     (onChange)="updateSelectedMUs($event)"
                     (onPanelHide)="muSelectorClosed()"
                     [showHeader]="true"
                     [filter]="false"
                     [disabled]="!_isGridValid || _isLoading"
                     emptyFilterMessage="{{'plan.details.dropdown.management.units.empty' | translate}}"
                     styleClass="fullrow">
        <ng-template let-value pTemplate="selectedItems">

            <!--<ng-container
              *ngTemplateOutlet="multiSelectSelectedItems;
              context: { value : value, emptyMessage:'historical-data.params.empty.selection' }">
            </ng-container>-->
            <esp-multi-select-content [items]="value" emptyMessage="plan.details.dropdown.management.units.empty.selection"> </esp-multi-select-content>

        </ng-template>
        <ng-template pTemplate="header">
          <esp-multi-select-filter [multiSelect]="muSelector"
            [searchAriaLabel]="'multi.select.filter.search.management.units' | translate">

          </esp-multi-select-filter>
        </ng-template>
        <ng-template pTemplate="footer">
          <esp-multi-select-footer [multiSelect]="muSelector">

          </esp-multi-select-footer>
        </ng-template>
        <ng-template let-item pTemplate="item">
          <esp-multi-select-item [item]="item"></esp-multi-select-item>
        </ng-template>
      </p-multiselect>
      <!--
        Stable aria-controls targets for the CT/MU comboboxes. They are NOT given
        role="listbox": an empty listbox in the accessibility tree is announced as
        "list box, 0 items". aria-controls only needs a valid IDREF to an existing
        element, so these stay as inert, visually hidden, role-less containers that
        screen readers ignore while still satisfying the combobox's aria-controls.
      -->
      <div id="ctSelector_list" class="sr-only"></div>
      <div id="muSelector_list" class="sr-only"></div>
    </div>
    <div class="toolbar-items-center">
      <validation-navigator [gridApi]="gridApi" [gridContext]="gridContext" [invalidCount]="_invalidCells.size" *ngIf="_invalidCells.size>0"></validation-navigator>
      <ng-template #undoButtonCtx>
        <div class="message-undo">
          <p>{{"plan.undo.paste.msg" | translate }} </p>
        </div>
        <div class="button-response">
          <breeze-button [isSecondary]="true" [showTooltip] = "false" buttonText="{{'plan.cancel.btn' | translate }}"></breeze-button>
          <breeze-button [isPrimary]="true" [showTooltip] = "false" buttonText="{{'btn.reset.label' | translate }}" (clicked)="discard()"></breeze-button>
        </div>
      </ng-template>
      <button *ngIf="isGridInvalid"
              [ngClass]="{'disabled': _isLoading}"
              class="btn btn-secondary btn-rect btn-small btn-discard"
              title="{{'plan.undo.btn' | translate}}"
              [disabled]="_isLoading"
              container="body"
              [ngbPopover]="undoButtonCtx"
              placement="bottom">
        <esp-icon name="undo-2" [size]="20"></esp-icon>
      </button>
    </div>
    <div class="toolbar-items-right text-right">
      <breeze-button buttonText="{{'plan.apply.btn'|translate}}" *ngIf="isMUgrid"
                     id="apply-mu-edits"
                     [isPrimary]="true"
                     [isDisabled]="isMUApplyDisabled || isGridInvalid || isManualEditing"
                     (clicked)="applyMUEdits()">
      </breeze-button>
      <breeze-button buttonText="{{'plan.apply.btn'|translate}}" *ngIf="!isMUgrid && CTDistMode=='FTE_REQUIRED'"
                     id="apply-distributions"
                     [isPrimary]="true"
                     [isDisabled]="!_isFTERequiredDirty || isGridInvalid || isManualEditing"
                     (clicked)="applyFTERequired()">
      </breeze-button>
        <button  *ngIf="multiStepWorkflow"
                  [ngClass]="{'disabled': _isLoading}"
                  class="btn btn-secondary btn-rect btn-small"
                  title="{{'multistep.workflow.button' | translate}}"
                  [disabled]="_isLoading || isGridInvalid"
                  (click)="showMswfRulesDlg()" >
          <esp-icon name="workflow" [size]="20"></esp-icon>
        </button>
      <div class="btn-group">
        <button  class="btn btn-secondary btn-rect btn-small float-right" title="{{'chart.btn.grid.view' | translate}}" [attr.aria-label]="'chart.btn.grid.view' | translate" [ngClass]="{'active':isChartView==false}" (click)="toggleChartButtonClicked(0)" [disabled]="isGridInvalid">
          <esp-icon class="toolbar-icon" name="table" [size]="20"></esp-icon>
        </button>
        <button class="btn btn-secondary btn-rect btn-small float-right" title="{{'chart.btn.chart.1.view' | translate}}" [attr.aria-label]="'chart.btn.chart.1.view' | translate" [ngClass]="{'active':isChartView && chartsCount==1}" (click)="toggleChartButtonClicked(1)" [disabled]="isGridInvalid">
          <esp-icon class="toolbar-icon" name="chart-line" [size]="20"></esp-icon>
        </button>
        <button class="btn btn-secondary btn-rect btn-small float-right" title="{{'chart.btn.chart.2.view' | translate}}" [attr.aria-label]="'chart.btn.chart.2.view' | translate" [ngClass]="{'active':isChartView && chartsCount==2}" (click)="toggleChartButtonClicked(2)" [disabled]="isGridInvalid">
          <esp-icon class="toolbar-icon" name="columns-2" [size]="20"></esp-icon>
        </button>
        <button class="btn btn-secondary btn-rect btn-small float-right" title="{{'chart.btn.chart.4.view' | translate}}" [attr.aria-label]="'chart.btn.chart.4.view' | translate" [ngClass]="{'active':isChartView && chartsCount==4}" (click)="toggleChartButtonClicked(4)" [disabled]="isGridInvalid">
          <esp-icon class="toolbar-icon" name="layout-grid" [size]="20"></esp-icon>
        </button>
      </div>
    </div>

  </div>
  <div class="row slider" [ngClass]="{'alternate':isChartView==true}">
    <!-- a11y (WCAG 2.4.3 Focus Order): both slides stay in the DOM and the
         inactive one is only translated off-screen, so its focusable content
         (AG Grid tab guards / scroll-region tab stop, or the chart's tabindex=0
         plot area) would otherwise stay in the tab order and swallow Tab focus
         while invisible. `inert` removes the off-screen slide from the tab order
         AND the accessibility tree, so Tab moves straight from the toolbar into
         whichever view is actually shown. -->
    <div class="col slide" style="" [ngClass]="{'active':isChartView==false}" [attr.inert]="isChartView ? '' : null">
      <div class="table-list editable-grid multi-cell-edit plan-detail-grid">

        <!-- A11y (WCAG 1.3.1 / 4.1.2): `ensureDomOrder` keeps the rendered cells
             in visual (left-to-right) order so a screen reader reads columns in
             the correct sequence. It is cheap and stays enabled for the CT view.
             `suppressColumnVirtualisation` is deliberately NOT set: forcing every
             column into the DOM (wide Weekly/Daily CT grids can have 50-365
             columns) rendered all columns for all rows and froze the grid /
             blanked the pinned Parameter column on scroll. Column virtualization
             is therefore left ON for performance; AG Grid's own keyboard
             navigation still scrolls off-screen cells into view, so keyboard
             users are not blocked (only the JAWS virtual-cursor sweep across
             not-yet-rendered columns degrades). -->
        <ag-grid-angular class="ag-theme-balham" [rowData]="rowData" #grid
                         [ngClass]="{'data-rendering':isRenderingData,'data-rendered':!isRenderingData,'rollup-collapsed':_isRollupCollapsed}"
                         [rowHeight]="36"
                         [headerHeight]="40"
                         [context]="gridContext"
                         [columnDefs]="colDefs"
                         [gridOptions]="gridOptions"
                         [stopEditingWhenCellsLoseFocus]="true"
                         [components]="frameworkComponents"
                         [suppressPreventDefaultOnMouseWheel]="true"
                         [loadingOverlayComponent]="loadingOverlayComponent"
                         [suppressScrollOnNewData]="true"
                         [debug]="false"
                         [ensureDomOrder]="isCTView"
                         [excelStyles]="excelStyles"
                         [cellSelection]="cellSelection"
                         [rowSelection]="rowSelection"
                         [loading]="false"
                         [enableBrowserTooltips]="true"
                         [animateRows]="false"
                         (newColumnsLoaded)="onGridColumnsChanged($event)"
                         [rowClassRules]="rowClassRules"
                         [defaultColDef]="defaultColDef"
                         (cellEditingStarted)="onCellEditingStarted()"
                         (cellEditingStopped)="onCellEditingStopped()"
                         [groupRowRenderer]="groupRowRenderer"
                         [groupRowRendererParams]="groupRowRendererParams"
                         (rowGroupOpened) = "rowGroupOpened($event)"
                         [isGroupOpenByDefault]="isGroupOpenByDefault"
                         [pinnedTopRowData]="topRowsData ?? undefined"
                         [frozenScroll]="gridApi"
                         [noRowsOverlayComponent]="'noRowsOverlay'"
                         [noRowsOverlayComponentParams]="noRowsComponentParams"
                         (gridReady)="onGridReady($event)">
        </ag-grid-angular>

      </div>
    </div>
    <div class="col slide" [ngClass]="{'active' : isChartView==true}" [attr.inert]="isChartView ? null : ''">

      <plan-multi-chart *ngIf="chartsCount==1 && hasRows" [chartsCount]="1" [contactType]="currentEntityView" [isVisible]="isChartView" [rowData]="allRowsData" [columnDefs]="colDefs" [viewMode]="gridContext.viewMode" [gridContext]="gridContext" [isLoading]="_isLoading" (drillDown)="updateViewMode(false)" (rollUp)="updateViewMode(true)" [locale]="locale"></plan-multi-chart>
      <plan-multi-chart *ngIf="chartsCount==2 && hasRows" [chartsCount]="2" [contactType]="currentEntityView" [isVisible]="isChartView" [rowData]="allRowsData" [columnDefs]="colDefs" [viewMode]="gridContext.viewMode" [gridContext]="gridContext" [isLoading]="_isLoading" (drillDown)="updateViewMode(false)" (rollUp)="updateViewMode(true)" [locale]="locale"></plan-multi-chart>
      <plan-multi-chart *ngIf="chartsCount==4 && hasRows" [chartsCount]="4" [contactType]="currentEntityView" [isVisible]="isChartView" [rowData]="allRowsData" [columnDefs]="colDefs" [viewMode]="gridContext.viewMode" [gridContext]="gridContext" [isLoading]="_isLoading" (drillDown)="updateViewMode(false)" (rollUp)="updateViewMode(true)" [locale]="locale"></plan-multi-chart>

      <wfm-esp-no-rows-overlay *ngIf="isChartView && hasRows==false" [params]="noRowsComponentParams">

      </wfm-esp-no-rows-overlay>
    </div>
  </div>
  <wfm-task-progress [task]="task" *ngIf="task">

  </wfm-task-progress>
</div>

<!-- Hidden file input for Excel import -->
<input type="file" #fileInput (change)="onFileSelected($event)" accept=".xlsx" style="display: none;">

<div class="dialog-container"></div>
<p-toast position="bottom-right" [baseZIndex]="1060">
</p-toast>
<router-outlet *ngIf="_isNestedRoute"></router-outlet>
